import { render, staticRenderFns } from "./ForbiddenList.vue?vue&type=template&id=a792fd48&scoped=true"
import script from "./ForbiddenList.vue?vue&type=script&lang=js"
export * from "./ForbiddenList.vue?vue&type=script&lang=js"
import style0 from "./ForbiddenList.vue?vue&type=style&index=0&id=a792fd48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a792fd48",
  null
  
)

export default component.exports